// import initialState from "../state/initialState";

// const authReducer = (state = initialState.auth, action) => {
//     switch (action.type) {
//         /* ===============================
//                   AUTH & COMMON
//         =============================== */
//         case "LOGIN_REQUEST":
//         case "LOGOUT_REQUEST":
//         case "GET_ENQUIRIES_REQUEST":
//         case "GET_ONE_ENQUIRY_REQUEST":
//         case "GET_NOTIFICATIONS_REQUEST":
//         case "GET_ONE_NOTIFICATION_REQUEST":
//         case "ADD_NOTIFICATION_REQUEST":
//         case "EDIT_NOTIFICATION_REQUEST":
//         case "DELETE_NOTIFICATION_REQUEST":
//         case "TOGGLE_NOTIFICATION_STATUS_REQUEST": // Added
//         case "GET_ALL_SERVICES_REQUEST":
//         case "GET_CLIENTS_REQUEST":
//         case "GET_ALL_EMPLOYEES_REQUEST":
//         case "GET_ALERTS_REQUEST": // Add this
//         case "ADD_ALERT_REQUEST":  // Add this
//         case "DELETE_ALERT_REQUEST":
//         case "TOGGLE_ALERT_STATUS":
//             return { ...state, loading: true };

//         case "LOGIN_SUCCESS":
//             return {
//                 ...state,
//                 loading: false,
//                 adminemail: action.payload,
//                 isAuthenticated: true,
//                 error: null,
//             };

//         case "LOGIN_FAILURE":
//         case "LOGOUT_SUCCESS":
//         case "LOGOUT_FAILURE":
//         case "GET_ALERTS_FAILURE":
//         case "ADD_ALERT_FAILURE":
//         case "DELETE_ALERT_FAILURE":
//         case "TOGGLE_ALERT_FAILURE":
//             return {
//                 ...state,
//                 loading: false,
//                 isAuthenticated: false,
//                 adminemail: null,
//                 error: action.payload || null,
//             };

//         /* ===============================
//                   NOTIFICATIONS
//         =============================== */
//         case "GET_NOTIFICATIONS":
//             return {
//                 ...state,
//                 loading: false,
//                 notifications: action.payload,
//             };
//         case "GET_ONE_NOTIFICATION":
//       return {
//         ...state,
//         loading: false,
//         notification: action.payload, // 👈 SINGLE NOTIFICATION
//       };
//         case "ADD_NOTIFICATION":
//             return {
//                 ...state,
//                 loading: false,
//                 notifications: [action.payload.notification, ...(state.notifications || [])],
//             };
//  case "EDIT_NOTIFICATION":
//       return {
//         ...state,
//         loading: false,
//         notifications: state.notifications.map((n) =>
//           n._id === action.payload.notification._id
//             ? action.payload.notification
//             : n
//         ),
//         notification: action.payload.notification, // 👈 keep edit page in sync
//       };
//         case "TOGGLE_NOTIFICATION_STATUS_SUCCESS": // Added
//             return {
//                 ...state,
//                 loading: false,
//                 notifications: state.notifications.map((n) =>
//                     // Use updatedNotification if from toggle, or notification if from edit
//                     n._id === (action.payload.updatedNotification?._id || action.payload.notification?._id) 
//                         ? (action.payload.updatedNotification || action.payload.notification) 
//                         : n
//                 ),
//             };
// case "DELETE_NOTIFICATION":
//             return {
//                 ...state,
//                 loading: false,
//                 notifications: state.notifications.filter((n) => n._id !== action.payload),
//             };

//         /* ===============================
//                   ENQUIRIES
//         =============================== */
//         case "GET_ENQUIRIES":
//             return {
//                 ...state,
//                 loading: false,
//                 allEnquiries: action.payload,
//             };

//         case "GET_ONE_ENQUIRY":
//             return {
//                 ...state,
//                 loading: false,
//                 enquiry: action.payload,
//             };

//         /* ===============================
//                   CLIENTS
//         =============================== */
//         case "ADD_CLIENT_REQUEST":
//         case "GET_ONE_CLIENT_REQUEST":
//         case "EDIT_CLIENT_REQUEST":
//         case "TOGGLE_CLIENT_REQUEST":
//             return { ...state, loading: true };

//         case "GET_CLIENTS":
//             return {
//                 ...state,
//                 loading: false,
//                 allClients: action.payload,
//             };

//         case "GET_ONE_CLIENT":
//             return {
//                 ...state,
//                 loading: false,
//                 client: action.payload,
//             };

//         case "ADD_CLIENT":
//         case "EDIT_CLIENT":
//         case "TOGGLE_CLIENT":
//             return { ...state, loading: false };

//         case "ADD_CLIENT_FAILURE":
//         case "GET_CLIENTS_FAILURE":
//         case "GET_ONE_CLIENT_FAILURE":
//         case "EDIT_CLIENT_FAILURE":
//         case "TOGGLE_CLIENT_FAILURE":
//             return { ...state, loading: false, error: action.payload };

//         /* ===============================
//                   SERVICES
//         =============================== */
//         case "GET_ALL_SERVICES":
//             return { ...state, loading: false, allServices: action.payload };

//         case "UPDATE_SERVICE_STATUS_LOCAL":
//             return {
//                 ...state,
//                 loading: false,
//                 allServices: state.allServices.map((service) =>
//                     service._id === action.payload.id
//                         ? { ...service, status: action.payload.status }
//                         : service
//                 ),
//             };

//             case "GET_MEMBER_TASKS":
//     return { 
//         ...state, 
//         loading: false, 
//         member_tasks: action.payload // Component now looks for this exact key
//     };
//             /* ===============================
//             ALERTS
// =============================== */
// case "GET_ALERTS":
//     return {
//         ...state,
//         loading: false,
//         allAlerts: action.payload, // This populates the "No rows" table
//     };

// case "ADD_ALERT":
//     return {
//         ...state,
//         loading: false,
//       allAlerts: [action.payload.alert, ...(state.allAlerts || [])],
//     };
// case "TOGGLE_ALERT_STATUS_SUCCESS": // Add this new case
//     return {
//         ...state,
//         loading: false,
//         allAlerts: state.allAlerts.map((alert) =>
//             alert._id === action.payload.updatedAlert?._id 
//                 ? action.payload.updatedAlert 
//                 : alert
//         ),
//     };
// case "DELETE_ALERT":
//     return {
//         ...state,
//         loading: false, // Ensure loading is turned off
//         allAlerts: state.auth.allAlerts.filter((alert) => alert._id !== action.payload), 
//         // action.payload should be the ID of the deleted alert
//     };
    
//         /* ===============================
//                   EMPLOYEES
//         =============================== */
//         case "GET_ALL_EMPLOYEES":
//             return { ...state, loading: false, allEmployees: action.payload };

//         case "GET_ONE_EMPLOYEE":
//             return { ...state, loading: false, employee: action.payload };

//         /* ===============================
//                   TASKS
//         =============================== */
//         case "GET_ALL_TASKS":
//             return {
//                 ...state,
//                 loading: false,
//                 allTasks: action.payload,
//             };

//         case "GET_CLIENT_TASKS":
//             return { ...state, loading: false, clientTasks: action.payload };


//         /* ===============================
//                   EVENTS
//         =============================== */
//         case "GET_ALL_EVENTS":
//             return { ...state, loading: false, allEvents: action.payload };

//         case "GET_ONE_EVENTS":
//             return { ...state, loading: false, events: action.payload };

//         /* ===============================
//                   COMPLIANCES
//         =============================== */
//         case "GET_ALL_COMPLIANCES":
//             return {
//                 ...state,
//                 loading: false,
//                 compliances: action.payload,
//             };

//         /* ===============================
//                   DEFAULT
//         =============================== */
//         default:
//             return state;
//     }
// };

// export default authReducer;
import initialState from "../state/initialState";

const authReducer = (state = initialState.auth, action) => {
    switch (action.type) {
        /* ===============================
                  AUTH & COMMON
        =============================== */
        case "LOGIN_SUCCESS":
            return {
                ...state,
                adminemail: action.payload,
                isAuthenticated: true,
            };

        case "LOGIN_FAILURE":
        case "LOGOUT_SUCCESS":
        case "LOGOUT_FAILURE":
            return {
                ...state,
                isAuthenticated: false,
                adminemail: null,
            };

        /* ===============================
                  NOTIFICATIONS
        =============================== */
        case "GET_NOTIFICATIONS":
            return {
                ...state,
                notifications: action.payload,
            };
        case "GET_ONE_NOTIFICATION":
            return {
                ...state,
                notification: action.payload,
            };
        case "ADD_NOTIFICATION":
            return {
                ...state,
                notifications: [action.payload.notification, ...(state.notifications || [])],
            };
        case "EDIT_NOTIFICATION":
            return {
                ...state,
                notifications: (state.notifications || []).map((n) =>
                    n._id === action.payload.notification._id ? action.payload.notification : n
                ),
                notification: action.payload.notification,
            };
        case "TOGGLE_NOTIFICATION_STATUS_SUCCESS":
            return {
                ...state,
                notifications: (state.notifications || []).map((n) =>
                    n._id === (action.payload.updatedNotification?._id || action.payload.notification?._id)
                        ? (action.payload.updatedNotification || action.payload.notification)
                        : n
                ),
            };
        case "DELETE_NOTIFICATION":
            return {
                ...state,
                notifications: (state.notifications || []).filter((n) => n._id !== action.payload),
            };

        /* ===============================
                  ENQUIRIES
        =============================== */
        case "GET_ENQUIRIES":
            return {
                ...state,
                allEnquiries: action.payload,
            };

        case "GET_ONE_ENQUIRY":
            return {
                ...state,
                enquiry: action.payload,
            };

        /* ===============================
                  CLIENTS
        =============================== */
        case "GET_CLIENTS":
            return {
                ...state,
                allClients: action.payload,
            };

        case "GET_ONE_CLIENT":
            return {
                ...state,
                client: action.payload,
            };

        case "TOGGLE_CLIENT":
            return {
                ...state,
                allClients: (state.allClients || []).map((c) =>
                    c._id === action.payload.id
                        ? { ...c, accountStatus: action.payload.status }
                        : c
                ),
                client: state.client?._id === action.payload.id
                    ? { ...state.client, accountStatus: action.payload.status }
                    : state.client,
            };

        /* ===============================
                  SERVICES
        =============================== */
        /* Inside authReducer.js */
case "GET_ALL_SERVICES":
    return {
        ...state,
        // Map _id to id for the DataGrid
        allServices: (Array.isArray(action.payload) ? action.payload : []).map(s => ({
            ...s,
            id: s._id // CRITICAL: DataGrid won't show rows without 'id'
        }))
    };
    case "UPDATE_SERVICE_SUCCESS":
    return {
        ...state,
        // Map the MongoDB _id to the DataGrid 'id' property
        allServices: (Array.isArray(action.payload) ? action.payload : []).map((s) => ({
            ...s,
            id: s._id // CRITICAL for DataGrid visibility
        })),
        loading: false
    };
        case "UPDATE_SERVICE_STATUS_LOCAL":
            return {
                ...state,
                allServices: (state.allServices || []).map((service) =>
                    service._id === action.payload.id
                        ? { ...service, status: action.payload.status }
                        : service
                ),
            };

        case "DELETE_SERVICE_SUCCESS":
            return {
                ...state,
                allServices: (state.allServices || []).filter(
                    (service) => service._id !== action.payload
                ),
            };

        case "GET_MEMBER_TASKS":
            return {
                ...state,
                member_tasks: action.payload
            };

        /* ===============================
                  DEPARTMENTS
        =============================== */
        case "GET_ALL_DEPARTMENTS":
            return {
                ...state,
                departments: action.payload, 
            };

        /* ===============================
                    ALERTS
        =============================== */
        case "GET_ALERTS":
            return {
                ...state,
                allAlerts: action.payload,
            };

        case "ADD_ALERT":
            return {
                ...state,
                allAlerts: [action.payload.alert, ...(state.allAlerts || [])],
            };
        case "TOGGLE_ALERT_STATUS_SUCCESS":
            return {
                ...state,
                allAlerts: (state.allAlerts || []).map((alert) =>
                    alert._id === action.payload.updatedAlert?._id
                        ? action.payload.updatedAlert
                        : alert
                ),
            };
        case "DELETE_ALERT":
            return {
                ...state,
                allAlerts: (state.allAlerts || []).filter((alert) => alert._id !== action.payload),
            };

        /* ===============================
                  EMPLOYEES
        =============================== */
        case "GET_ALL_EMPLOYEES":
            return { ...state, allEmployees: action.payload };

        case "GET_ONE_EMPLOYEE":
            return { ...state, employee: action.payload };

        case "TOGGLE_EMPLOYEE":
            return {
                ...state,
                allEmployees: (state.allEmployees || []).map((emp) =>
                    emp._id === action.payload.id
                        ? { ...emp, accountStatus: action.payload.status }
                        : emp
                ),
                employee: state.employee?._id === action.payload.id
                    ? { ...state.employee, accountStatus: action.payload.status }
                    : state.employee,
            };

        /* ===============================
                  TASKS
        =============================== */
        case "GET_ALL_TASKS":
            return {
                ...state,
                allTasks: action.payload,
            };

        case "GET_CLIENT_TASKS":
            return { ...state, clientTasks: action.payload };

        case "DELETE_TASK_SUCCESS":
            return {
                ...state,
                clientTasks: (state.clientTasks || []).filter((task) => (task._id || task.id) !== action.payload),
                allTasks: (state.allTasks || []).filter((task) => (task._id || task.id) !== action.payload),
            };

        /* ===============================
                  EVENTS
        =============================== */
        case "GET_ALL_EVENTS":
            return { ...state, allEvents: action.payload };

        case "GET_ONE_EVENTS":
            return { ...state, events: action.payload };

        /* ===============================
                  COMPLIANCES
        =============================== */
        case "GET_ALL_COMPLIANCES":
            return {
                ...state,
                compliances: action.payload,
            };
           /* Inside your authReducer.js switch statement */

          case "GET_ALL_MAILS":
  return {
    ...state,
    allMails: action.payload,
    mail: state.mail, // ✅ PRESERVE CURRENT MAIL
  };
  case "GET_MAIL_SUCCESS":
  console.log("🔥 AUTH REDUCER HIT", action.payload);
  return {
    ...state,
    mail: action.payload,
  };

        /* ===============================
                  DEFAULT
        =============================== */
        default:
            return state;
    }
};

export default authReducer;